import React, { useContext } from 'react';
import { Grid } from '@material-ui/core';
import { Carousel } from '@thd-olt-component-react/core-ui';
import { InfoPerksContext } from '../../../../contexts';
import { SmallAlert } from '../../shared/components/SmallAlert/SmallAlert';
import { useCurrentPerkStatusDetails } from '../utils';
import { ProgressBar, ProgressBarLast } from './ProgressBar';
import { perksHistory } from '../../../../constants';
import { getImageURL } from '../../../../utils/GeneralUtil';
import { fallbackImage } from '../../shared/commons';
export var HistoryCarousel = function () {
    var _a = useContext(InfoPerksContext), perkHistoryList = _a.perkHistoryList, isLoading = _a.isLoading;
    var getCurrentPerkStatusDetails = useCurrentPerkStatusDetails();
    if (isLoading || !perkHistoryList) {
        return null;
    }
    var slides = perkHistoryList.map(function (perk, index) {
        var currentPerkStatusDetails = getCurrentPerkStatusDetails(perk);
        var currentPerkDetails = perk.perkDisplaySeqNumber
            ? perk
            : perk.tierPerks[0];
        var isLast = index === perkHistoryList.length - 1;
        var captionWidth = currentPerkStatusDetails.caption === 'Unclaimed Perk Expired'
            ? '110px'
            : '120px';
        return (React.createElement(Grid, { item: true, xs: 12, key: index, className: "PerkHistory sui-flex sui-flex-col sui-justify-start sui-align-center" },
            React.createElement(Grid, { className: "PerkHistoryTitleAndChip sui-flex sui-flex-col sui-justify-start sui-align-center" },
                React.createElement(Grid, { className: "sui-flex sui-flex-row sui-justify-center sui-align-center" },
                    React.createElement("p", { className: "PerkHistoryTitle" }, currentPerkStatusDetails.caption === 'Inactive'
                        ? 'Inactive'
                        : currentPerkStatusDetails.title)),
                React.createElement("div", { className: "PerkHistoryChipIconContainer" }, !currentPerkDetails.adminIssued &&
                    (currentPerkDetails.renewed || currentPerkDetails.exchanged) && (React.createElement("div", { className: "PerkHistoryChipIcon" },
                    React.createElement("p", null, currentPerkDetails.renewed
                        ? perksHistory.renewed
                        : perksHistory.exchanged))))),
            React.createElement(Grid, { className: "PerkHistoryProgressBarAndLogoContainer sui-relative" },
                React.createElement(ProgressBar, { index: index, completed: currentPerkDetails.adminIssued ? 100 : perk.progressPercentage }),
                React.createElement("div", { className: "sui-absolute sui-align-center sui-flex sui-justify-center sui-left-0 sui-mt-2 sui-right-0 sui-top-0" },
                    React.createElement("img", { src: getImageURL(currentPerkStatusDetails.imgName), alt: currentPerkStatusDetails.imgAltText || 'perk-img', className: "PerkHistoryLogo", height: "55px", width: "55px", onError: fallbackImage })),
                isLast && React.createElement(ProgressBarLast, null)),
            React.createElement(Grid, { className: "PerkHistoryCaption sui-flex sui-flex-row sui-justify-center sui-align-center" },
                React.createElement("p", { style: {
                        width: captionWidth,
                    } }, currentPerkStatusDetails.caption)),
            React.createElement(Grid, { className: "PerkHistorySubCaption sui-text-md sui-flex sui-flex-col sui-justify-start sui-align-start sui-pt-4" }, currentPerkStatusDetails.subCaption),
            React.createElement(Grid, { className: "PerkHistory__CardExpiring sui-flex sui-flex-row sui-justify-center sui-align-center" }, currentPerkDetails.daysLeft <= 14 && (React.createElement(SmallAlert, { alertMessage: currentPerkStatusDetails.alertMessage })))));
    });
    return (React.createElement("div", null,
        React.createElement("div", { className: "PerkHistory__Summary" }, perksHistory.summary),
        React.createElement("div", null,
            React.createElement(Carousel, { fade: true, navigation: true, dotsBelow: true, peek: false, slidesPerView: "auto", slidesPerGroup: 1, breakpoints: {
                    sm: {
                        slidesPerView: 3,
                        slidesPerGroup: 1,
                    },
                    md: {
                        slidesPerView: 4,
                        slidesPerGroup: 1,
                    },
                    lg: {
                        slidesPerView: 5,
                        slidesPerGroup: 1,
                    },
                    xl: {
                        slidesPerView: 5,
                        slidesPerGroup: 1,
                    },
                } }, slides))));
};
